<template>
    <div class="page-cabinet-referral-info-list-table">
        <ui-table v-bind="tableData" theme="secondary" />
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
    name: 'page-cabinet-referral-info-list-table',
    computed: {
        ...mapState('referral', [
            'getReferralsResult',
        ]),
        tableData() {
            const columns = [
                {
                    title: 'ФИО',
                    style: { flex: '1 1 469px' },
                },
                {
                    title: 'Статус',
                    style: { flex: '1 1 291px' },
                },
                {
                    title: 'Сумма инвестиции',
                    style: { flex: '0 0 180px' },
                },
                {
                    title: 'Комиссия',
                    style: { flex: '1 1 155px' },
                },
                {
                    title: 'Выплата',
                    style: { flex: '1 1 155px' },
                },
            ];
            const rows = this.getReferralsResult.map(x => ({
                cells: [
                    {
                        props: {
                            text: x.name,
                        },
                    },
                    {
                        type: 'component',
                        component: 'page-cabinet-referral-info-list-status',
                        props: {
                            code: x.status,
                        },
                    },
                    {
                        props: {
                            text: x.investment > 0 ? x.investmentFormatted : '–',
                        },
                    },
                    {
                        props: {
                            text: x.investment > 0 ? x.feeFormatted : '–',
                        },
                    },
                    {
                        type: 'component',
                        component: 'page-cabinet-referral-info-list-payment-status',
                        props: {
                            code: x.paymentStatus,
                        },
                    },
                ],
                details: this.getDetailsData(x.investments),
            }));
            rows.push();
            return {
                columns,
                rows,
            };
        },
    },
    methods: {
        getDetailsData(investments) {
            if (investments.length > 0) {
                const columns = [
                    {
                        title: 'Инвестиция',
                        style: { flex: '1 1 187px' },
                    },
                    {
                        title: 'Сумма инвестиций',
                        style: { flex: '1 1 265px' },
                    },
                    {
                        title: 'Ставка',
                        style: { flex: '1 1 265px' },
                    },
                    {
                        title: 'Комиссия',
                        style: { flex: '1 1 265px' },
                    },
                    // {
                    //     title: 'Выплата',
                    //     style: { flex: '1 1 155px' },
                    // },
                ];
                const rows = investments.map(x => ([
                    {
                        props: {
                            text: String(x.index),
                        },
                    },
                    {
                        props: {
                            text: x.investmentFormatted,
                        },
                    },
                    {
                        props: {
                            text: x.commissionPercentFormatted,
                        },
                    },
                    {
                        props: {
                            text: x.commissionFormatted,
                        },
                    },
                    // {
                    //     type: 'component',
                    //     component: 'page-cabinet-referral-info-list-payment-status',
                    //     props: {
                    //         code: x.paymentStatus,
                    //     },
                    // },
                ]));
                return {
                    columns,
                    rows,
                };
            }
            return null;
        },
    },
};
</script>

<style scoped lang="less">
@import '~theme';

.page-cabinet-referral-info-list-table {
}
</style>
